const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = query
    ? '?' + Object.entries(query).filter(([_, v]) => v !== undefined && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
    : '';
  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const signalementsApi = {
  // Public — n'importe qui peut signaler (anonyme accepté)
  list:        (opts)        => request('/signalements',           { query: opts }),
  getByRef:    (reference)   => request(`/signalements/${encodeURIComponent(reference)}`),
  create:      (body, token) => request('/signalements',           { method: 'POST', body, token }), // token optionnel
  // Admin
  adminList:   (token, opts) => request('/admin/signalements',     { token, query: opts }),
  adminGet:    (token, id)   => request(`/admin/signalements/${id}`, { token }),
  adminUpdate: (token, id, b)=> request(`/admin/signalements/${id}`, { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)   => request(`/admin/signalements/${id}`, { method: 'DELETE', token }),
};

export const SIG_CATEGORIES = [
  { id: 'all',           lbl: 'Toutes' },
  { id: 'voirie',        lbl: 'Voirie' },
  { id: 'proprete',      lbl: 'Propreté' },
  { id: 'eclairage',     lbl: 'Éclairage' },
  { id: 'eau',           lbl: 'Eau' },
  { id: 'securite',      lbl: 'Sécurité' },
  { id: 'environnement', lbl: 'Environnement' },
  { id: 'autre',         lbl: 'Autre' },
];

export const SIG_PRIORITIES = [
  { id: 'all',     lbl: 'Toutes priorités' },
  { id: 'urgent',  lbl: 'Urgent' },
  { id: 'normal',  lbl: 'Normal' },
  { id: 'faible',  lbl: 'Faible' },
];

export const SIG_STATUSES = [
  { id: 'all',      lbl: 'Tous statuts' },
  { id: 'nouveau',  lbl: 'Nouveau' },
  { id: 'en_cours', lbl: 'En cours' },
  { id: 'resolu',  lbl: 'Résolu' },
  { id: 'rejete',   lbl: 'Rejeté' },
  { id: 'doublon',  lbl: 'Doublon' },
];

export const CATEGORY_LABEL = Object.fromEntries(SIG_CATEGORIES.map((c) => [c.id, c.lbl]));
export const PRIORITY_LABEL = Object.fromEntries(SIG_PRIORITIES.map((p) => [p.id, p.lbl]));
export const STATUS_LABEL   = Object.fromEntries(SIG_STATUSES.map((s) => [s.id, s.lbl]));
